export default {
	"order.transferOrder": "transfer order",
	"order.NoRefund": "No refund",
	"order.Refunding": "Refunding",
	"order.RefundSuccessfully": "Refund successfully",
	"order.PendingPayment": "Pending payment",
	"order.toBeDelivered": "to be delivered",
	"order.PartiallyShipped": "Partially shipped",
	"order.Shipped": "Shipped",
	"order.TransactionComplete": "Transaction complete",
	"order.TradingClosed": "Trading closed",
	"order.PaidWithoutAddress": "Paid without address",
	"order.NoDeliveryRequired": "No delivery required",
	"order.ExpressDelivery": "Express delivery",
	"order.OnlyRefund": "Only refund",
	"order.refundReturn": "refund / return",
	"order.pendingReview": "pending review",
	"order.passed": "passed",
	"order.rejected": "rejected",
	"order.Revoked": "Revoked",
	"order.creationTime": "creation time",
	"order.passingTime": "passing time",
	"order.rejectionTime": "rejection time",
	"order.CancellationTime": "Cancellation time",
	"order.call": "call",
	"order.calledMath": "called math",
	"order.calledLiteracy": "called literacy",
	"order.DownloadTheCallingLiteracyAPP": "Download the [Calling Literacy] APP",
	"order.clickToDownload": "click to download",
	"order.OrScanTheCodeToDownloadAfterRegisteringAndLoggingInYouCanRedeemAndViewTheLiterateContent": "Or scan the code to download, after registering and logging in, you can redeem and view the literate content"
}